import { Injectable } from '@angular/core'
import { WebService } from '../api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { map } from 'rxjs'
import { UserAPIModel } from 'src/app/models/api.model'

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private webservice: WebService) {}

  invokeFetchAssigneeList() {
    const endPoint = ServiceUrlConstants.API_ASSIGNEE_LIST
    return this.webservice
      .get(endPoint)
      .pipe(map((assignees: UserAPIModel[]) => assignees))
  }

}
